import React from 'react';
import {useSelector} from 'react-redux';

import appConfig from '../../config/appConfig';
import languageService from '../../services/localization/languageService';
import {initLocalizations} from '../../services/localization/localizationService';
import {selectLanguageCode} from '../../state/selectors/global';
import AppSelect from './AppSelect';

const LanguageSelect = () => {
    const languages = appConfig.getLanguages();
    const languageCode = useSelector(selectLanguageCode);
    const defaultLanguage = getDefaultLanguageValue(languages, languageCode);
    const handleChange = async ({languageCode}) => {
        if (languageCode !== defaultLanguage.languageCode) {
            await initLocalizations(languageCode);
            languageService.setLanguageCodeToStores(languageCode);
        }
    };

    return (
        <AppSelect
            key={languageCode} //fix language select not responding after multiple language change on tnc page
            defaultValue={defaultLanguage}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.languageCode}
            options={languages}
            onChange={handleChange}
            isSearchable={false}
        />
    );
};

export default LanguageSelect;

const getDefaultLanguageValue = (languages, languageCode) => {
    let defaultValue = languages.find((lang) => lang.languageCode === languageCode);

    if (!defaultValue) {
        defaultValue = languageService.getDefaultLanguage();
    }

    return defaultValue;
};
